// extracted by mini-css-extract-plugin
export default {"onboardingOverlay":"Yn5qtFkAUwDQio8l4oaG","drawer":"WQ0Oz4qsYpqffvitUQ5n","bg":"HHt0De8OqlIVfbt0xXQQ","onboardingContent":"ggyoRorUFB7gT0DfVHUA"};